module.exports = __webpack_public_path__ + "img/gamification-1-mobile.bbaefe6c.png";